import * as React from 'react';

import type { IconProps } from '../types';

const StatusInReview = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 16, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        <path
          fill="hsl(var(--twc-status-icon-in-review))"
          d="M7.75 1.57768C7.75 1.30483 7.97094 1.08181 8.24244 1.10128C8.98 1.15418 9.70539 1.32566 10.3905 1.61013C11.2277 1.95771 11.9883 2.46718 12.629 3.10943C13.2698 3.75168 13.778 4.51414 14.1248 5.35329C14.4715 6.19243 14.65 7.09182 14.65 8.0001C14.65 8.90838 14.4715 9.80777 14.1248 10.6469C13.778 11.4861 13.2698 12.2485 12.629 12.8908C11.9883 13.533 11.2277 14.0425 10.3905 14.3901C9.70539 14.6745 8.98 14.846 8.24244 14.8989C7.97094 14.9184 7.75 14.6954 7.75 14.4225L7.75 1.57768Z"
        />
      </svg>
    );
  }
);

StatusInReview.displayName = 'StatusInReview';

export { StatusInReview };
